<template lang="pug">

div

    //- Navigation
    navigation

    //- Content
    form.ui.form(v-on:submit.prevent="submit()")

        .ui.top.attached.header Allgemeine Angaben:
        .ui.bottom.attached.segment
            general-information-form(
                ref='generalInformationForm'
                v-bind:mediaProductionUserModels="mediaProductionUsers"
                v-bind:personModels="persons"
                v-model="company"
        )

        .ui.top.attached.header Zusätzliche Angaben:
        .ui.bottom.attached.segment
            additional-information-form(
                ref='additionalInformationForm'
                v-bind:companyModels="companies"
                v-model="company"
            )

        .ui.bottom.secondary
                .ui.column.grid
                    .right.aligned.column
                        a.ui.labeled.icon.button(v-on:click='cancel()')
                            i.remove.icon
                            |  Abbrechen
                        button.ui.labeled.primary.icon.button
                            i.checkmark.icon
                            |  Speichern

</template>

<script>
    import * as R from 'ramda'
    import { handle_multiple_validations } from '@/utils/validate'
    import store from '@/store'
    import AdditionalInformationForm from '@/components/companies/forms/AdditionalInformation.vue'
    import GeneralInformationForm from '@/components/companies/forms/GeneralInformation.vue'
    import Navigation from '@/components/companies/Navigation.vue'

    //noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
    export default {
        name: 'companies-update-view',

        components: {
            AdditionalInformationForm, GeneralInformationForm, Navigation
        },

        beforeRouteEnter(to, from, next) {
            Promise.all([

                // Das zu bearbeitende Unternehmen laden
                store.dispatch('companies/loadOne', { id: to.params.id }),

                // Nur Medienproduktioner laden + deren Personen (statt loadAll + persons/loadAll)
                // companies/loadAll wird lazy geladen (in AdditionalInformation.vue wenn "Agentur" angehakt bzw. bereits gesetzt)
                store.dispatch('users/loadAllByHasMediaProductionRole').then(users =>
                    Promise.all(users.map(user => store.dispatch('persons/loadOne', { id: user.person })))
                ),

            ]).then(next)
        },

        computed: {
            companies() {
                return store.getters['companies/all']
            },

            mediaProductionUsers() {
                return store.getters['users/allByHasMediaProductionRole']
            },

            persons() {
                return store.getters['persons/all']
            }
        },

        created() {
            this.company = store.getters['companies/byId'](this.$route.params.id)
        },

        data() {
            return {
                company: {},
            }
        },

        methods: {
            cancel() {
                this.$router.push({ name: 'companies' })
            },

            submit() {
                this.validate().then(R.when(R.equals(true), () => {

                    // Speichern
                    return store.dispatch('companies/update', { model: this.company }).then(() => {
                        this.$growl.success('Unternehmen wurde aktualisiert')
                        this.$router.push({ name: 'companies' })
                    })

                })).catch(e => {
                    const msg = 'Unternehmen konnte nicht gespeichert werden. Bitte den Service kontaktieren'
                    this.$growl.fatal(msg, e)
                })


            },

            validate() {

                return Promise.all([
                    this.$refs.additionalInformationForm.validate(),
                    this.$refs.generalInformationForm.validate(),
                ])
                    .then(handle_multiple_validations(this.$scrollToErrorAndFocus))
            }

        }

    }

</script>
